export const CONFIGURATION = {
  appName: "osb-portal",
};
